define('viewmodels/configuration/RiskFactor',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'durandal/system', 'services/logger'], function (ko, router, appsecurity, navigation, app,system,logger) {
    var title = 'RiskFactors';

    var RiskFactorViewModal = {
        activate: activate,
        attached: attached,
        detached: detached,
        RiskFactorDtPageNumber: ko.observable(0),
        RiskAreasList: ko.observableArray(),
        RiskAreaDrpDwnList: ko.observableArray(),
        SelectedAreaName: ko.observable(),
        RiskFactorList: ko.observableArray(),   // for storing the data in the model or from a row into the riskfactorlist
        popUpTitle: ko.observable(),            // Title of the popup for adding and editing risk area   
        addFunctionality: addFunctionality,     // add button event for adding the risk area
        title: title,
        logger: logger,
        appsecurity:appsecurity,
        //thresholdtable: thresholdtable,
        //thresholdtablebody: thresholdtablebody,
        editableRiskFactor: ko.observable(),
        editFunctionality: editFunctionality,
        deleteFunctionality: deleteFunctionality,
        savePopUpButton: savePopUpButton,
        cancelPopUpButton: cancelPopUpButton,

        //----------------Object Variables for the Sub Factor and Threshold Part-------------------------------------------------------------------------------
        RiskScoreDrpDwnList: ko.observableArray(),
        RiskScore: ko.observable(),
        RiskLevel: ko.observable(),
        RiskLevelDescription: ko.observableArray(),
        RiskSubFactorsList: ko.observableArray(),
        editRiskSubFactorFunctionality: editRiskSubFactorFunctionality,
        addRiskSubFactorFunctionality: addRiskSubFactorFunctionality,
        deleteRiskSubFactorFunctionality: deleteRiskSubFactorFunctionality,
        editableRiskSubFactor: ko.observable(),
        rsfPopUpTitle: ko.observable(),
        RiskFactorId: ko.observable(),
        saveRsfButton: saveRsfButton,
        cancelRsfButton: cancelRsfButton,
        ThresholdValues: ko.observableArray(),
        addPopUpCss: ko.observable(true),
        editPopUpCss: ko.observable(true),
        dtobservable: ko.computed(function () {
            return appsecurity.finalConfigurationSave();
        }).extend({ notify: 'always' }),
        configuartionSaveState: ko.observable(false)
    };

    return RiskFactorViewModal;
    var isEdit,isRsfEdit, RfTableObj, RfSubFactorTableObj = false;
    var GetAllRiskFactorsAjax = {};
    var AddRiskFactorAjax = {};
    var UpdateRiskFactorAjax = {};
    var GetAllRiskAreasAjax = {};
    var GetAllRiskSubFactorsAjax = {};

    function test(newValue) {

        if (newValue == false && RfTableObj != undefined) {

            RiskFactorViewModal.configuartionSaveState(true);
            RfTableObj.draw(false);

        }
    }
    function tableCallBack(val) {
       
        if (RiskFactorViewModal.configuartionSaveState()) {
            for (i = 1, j = ($('#tblRiskFactor').find('tr').length) ; i < j; i++) {
                var editControl = $($($('#tblRiskFactor').find('tr').get(i)).find('td').get(3)).find('a').get(0);
                var deleteControl = $($($('#tblRiskFactor').find('tr').get(i)).find('td').get(3)).find('a').get(1);
                ko.cleanNode(editControl);
                ko.cleanNode(deleteControl);
                ko.applyBindingsToNode(editControl, { click: RiskFactorViewModal.editFunctionality, css: { 'disabled': (!RiskFactorViewModal.appsecurity.finalConfigurationSave()) } }, RiskFactorViewModal);
                ko.applyBindingsToNode(deleteControl, { click: RiskFactorViewModal.deleteFunctionality, css: { 'disabled': (!RiskFactorViewModal.appsecurity.finalConfigurationSave()) } }, RiskFactorViewModal);
                $('#tblRiskFactor').find('tr').get(i).removeAttribute('class', 'shown');
            }
        }
        else
            ko.applyBindingsToNode($('#tblRiskFactor'));

    }
   

    function activate() {
        RiskFactorViewModal.dtobservable.subscribe(test);
        return true;
    };

    function detached() {
        $($(document.getElementsByClassName('list-group-item')).get(4)).removeClass('active');

    };

    function attached() {
        $($(document.getElementsByClassName('list-group-item')).get(4)).addClass('active');
        $($(document.getElementsByClassName('nav navbar-nav navbar-left')).get(4)).addClass('active');
        try{
            GetAllRiskFactorsAjax = {
                url: "/api/Configuration/GetAllRiskFactor",
                type: "GET"
            };

            GetAllRiskFactors(GetAllRiskFactorsAjax);

            GetAllRiskAreasAjax = {
                url: "/api/Configuration/GetAllRiskAreas",
                type: "GET"
            };

            GetClientDetails();
            GetRiskLevelDescription();

            
            $('#tblRiskFactor').on('page.dt', function (event) {
               // 


;
                if (event.target == this) {
                    var info = RfTableObj.page.info();
                    var rowsInTable = $('#tblRiskFactor').find('tr');
                    for (var i = 1, j = (rowsInTable.length) ; i < j; i++) {

                        var tr = $('#tblRiskFactor').find('tr').get(i);
                        var tableRowIndex = (RiskFactorViewModal.RiskFactorDtPageNumber() * info.length) + (i - 1);
                        if ((RfTableObj.row(tableRowIndex).child() != undefined) && (RfTableObj.row(tableRowIndex).child.isShown())) {
                            RfTableObj.row(tableRowIndex).child.remove();
                            tr.removeAttribute('class', 'shown')
                            j = $('#tblRiskFactor').find('tr').length;
                        }
                    }

                    RiskFactorViewModal.RiskFactorDtPageNumber(info.page)
                }
                //alert("Now going to show Page " + (RfTableObj.page.info().page + 1) + " of Pages " + RfTableObj.page.info().pages);
            });
           
          
            $('#tblRiskFactor tbody').on('click', 'td.details-control', function (event) {
                
                var tr = $(this).closest('tr');
                var row = RfTableObj.row(tr);
                checkExpandedRow(row, false);
                if (row.child.isShown()) {
                    // This row is already open - close it
                    row.child.hide();
                    tr.removeClass('shown');
                }
                else {
                    // Open this row
                    row.child(format(row.data())).show();
                    tr.addClass('shown');
           

                   
                    ko.applyBindingsToNode($('#Threshold').find('tbody').get(0), { foreach: RiskFactorViewModal.ThresholdValues }, RiskFactorViewModal);
                    ko.applyBindingsToNode($('#subfactor').find('tbody').get(0), { foreach: RiskFactorViewModal.RiskSubFactorsList }, RiskFactorViewModal);
                    //ko.applyBindingsToNode($('#frmSubFactor').find('form').get(0), { with: RiskFactorViewModal.editableRiskSubFactor() }, RiskFactorViewModal);
                    ko.applyBindingsToNode($('#frmSubFactor').find('h4').get(0), { text: RiskFactorViewModal.rsfPopUpTitle() }, RiskFactorViewModal);
                    ko.applyBindingsToNode($('#addSubFactorBtn'), { disabled: true, click: RiskFactorViewModal.addRiskSubFactorFunctionality }, RiskFactorViewModal);
                    $('#addSubFactorBtn').attr("disabled",(!RiskFactorViewModal.appsecurity.finalConfigurationSave()))
                    //ko.applyBindingsToNode($('#subfactor').find('a').get(0), {click: RiskFactorViewModal.editRiskSubFactorFunctionality}, RiskFactorViewModal)
                    //ko.applyBindingsToNode($('#subfactor').find('a').get(1), {click: RiskFactorViewModal.deleteRiskSubFactorFunctionality}, RiskFactorViewModal)
                    
                    RfSubFactorTableObj = $("#subfactor").DataTable({
                        "bInfo": false,
                        "bResponsive": true,
                        "bPaginate": true,
                        
                        "aoColumnDefs": [{
                            "aTargets": [0],
                            "bVisible": false
                        },{
                            "aTargets": [2],
                            "bSortable": true
                        },{
                            "aTargets": [3],
                            "bSortable": false,
                            "sClass": "text-center"
                  
                        }]
                       
                    }).draw(false);
         
                   
                    var table = $('#Threshold').dataTable({
                        bFilter: false, bInfo: false, bPaginate: false, 
                    });
                    if (RiskFactorViewModal.appsecurity.finalConfigurationSave()) {
                        table.makeEditable({
                            sUpdateURL: function (data, a) {
                                var row_id = this.parentNode._DT_RowIndex;
                                var col_id = table.fnGetPosition(this)[2];
                 
                               
                                var newValue = data;
                      
                           
                                var oldValue = RiskFactorViewModal.ThresholdValues()[row_id][RiskFactorViewModal.RiskLevelDescription()[col_id - 1]];
                                if (oldValue == null)
                                { oldValue = 0; }
                                if (newValue == "") {
                                
                                    table.fnUpdate(oldValue, row_id, col_id, true);
                                    RiskFactorViewModal.ThresholdValues()[row_id][RiskFactorViewModal.RiskLevelDescription()[col_id - 1]] = oldValue;
                                    table.fnDraw(false);


                                }
                               else if (newValue < 0 || newValue>100) {
                                    $('#lblThresholdError').show();
                                    $('#lblThresholdError').text("Threshold value should be between 0 and 100");
                                    table.fnUpdate(oldValue, row_id, col_id, true);
                                    RiskFactorViewModal.ThresholdValues()[row_id][RiskFactorViewModal.RiskLevelDescription()[col_id - 1]] = oldValue;
                                    table.fnDraw(false);

                                }
                               else if (!$.isNumeric(newValue)) {
                                    $('#lblThresholdError').show();
                                    $('#lblThresholdError').text("Threshold value should be numeric");
                                    table.fnUpdate(oldValue, row_id, col_id, true);
                                    RiskFactorViewModal.ThresholdValues()[row_id][RiskFactorViewModal.RiskLevelDescription()[col_id - 1]] = oldValue;
                                    table.fnDraw(false);

                               }
                               else if (newValue % 1 != 0) {
                                   $('#lblThresholdError').show();
                                   $('#lblThresholdError').text("Threshold value should be an integer");
                                   table.fnUpdate(oldValue, row_id, col_id, true);
                                   RiskFactorViewModal.ThresholdValues()[row_id][RiskFactorViewModal.RiskLevelDescription()[col_id - 1]] = oldValue;
                                   table.fnDraw(false);

                               }
                              
                               else {
                                   newValue = parseInt(newValue, 10);
                                  $('#lblThresholdError').hide();
                                var maxRiskScoreValue = row_id + 1;
                                var riskLevel = RiskFactorViewModal.RiskLevelDescription()[col_id - 1];
                                var options = {

                                    url: "/api/Configuration/UpdateThresholdCell?RiskFactorId=" + RiskFactorViewModal.RiskFactorId() + "&RiskScore=" + maxRiskScoreValue + "&RiskLevel=" + riskLevel + "&Value=" + newValue,
                                    headers: appsecurity.getSecurityHeaders(),
                                    type: "POST"


                                };

                                // Make the ajax Call
                                $.ajax(options).success(ajaxSuccess)
                                .fail(ajaxFail);

                                function ajaxSuccess(result, status) {
                           
                               
                                    if (result == 1) {
                                
                                   
                                        table.fnUpdate(newValue, row_id, col_id, true);
                                        RiskFactorViewModal.ThresholdValues()[row_id][RiskFactorViewModal.RiskLevelDescription()[col_id - 1]] = newValue;
                               
                                        table.fnDraw(false);
                                    
                                    }


                                }

                                function ajaxFail(status, errormessage) {
                                    
                                }


                                }
                            },

                            aoColumns: [
                                            null,
                                {
                                },
                                {

                                },

                                {

                                }
                            ]
                        });
                    }
                    $('#subfactor').on('page.dt', function (event) {
                      
                        
                        // event.stopPropagation();
                    //    event.stopImmediatePropagation();
                    });
                }
            });

        
     

        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: attached() method in RiskFactor.js';
            logger.logMessage(msg);
        }

    }
   


    function GetClientDetails() {
        try{
            $.ajax({
                url: "/api/Configuration/GetClientDetails",
                type: "GET",
                async: false,
                headers: appsecurity.getSecurityHeaders()
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetClientDetails() method in RiskFactor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            // 
            try{
                if (jsonResult != null) {
                    RiskFactorViewModal.RiskScoreDrpDwnList.removeAll();
                    RiskFactorViewModal.RiskLevel(jsonResult.RiskLevel);
                    RiskFactorViewModal.RiskScore(jsonResult.MaxRiskScore);
                    for (var i = 1, j = jsonResult.MaxRiskScore; i <= j ; i++)
                        RiskFactorViewModal.RiskScoreDrpDwnList.push(i);
                }
                else {
                    logger.logError('Client details are not present , please fill the Client details and then try using this page.', 'Error', system.getModuleId(RiskFactorViewModal), true);
                }
            }catch(e)
            {
         
            var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in GetClientDetails() method in RiskFactor.js';
            logger.logMessage(msg);
        }
        }

        function ajaxFail(error, status) {
            // 
            try{
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"],false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            router.navigate("configuration", true);
                        //router.refresh(true);
                        //navigation.unauthorized();
                    })
                }
                else{
                    var msg = 'Exception: ' + error.responseText + ' | Source:ajaxFail in GetClientDetails() method in RiskFactor.js';
                    logger.logMessage(msg);
                }
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail in GetClientDetails() method in RiskFactor.js';
                logger.logMessage(msg);
            }
        }
    };


        function GetRiskLevelDescription() {
            try{
                $.ajax({
                    url: "/api/Configuration/GetAllRiskLevelDescription?RiskLevel=" + RiskFactorViewModal.RiskLevel(),
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                .success(ajaxSuccess)
                .fail(ajaxFail);
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source:ajax call in GetRiskLevelDescription() method in RiskFactor.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try{
                    if (jsonResult != null) {
                        RiskFactorViewModal.RiskLevelDescription(jsonResult);
                    }
                    else
                        logger.logError('Failed to fetch details, please reload the page and try again.', 'Error', system.getModuleId(RiskFactorViewModal), true);
                }catch(e)
                {
                
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in GetRiskLevelDescription() method in RiskFactor.js';
                logger.logMessage(msg);
         
                }
        };

        function ajaxFail(error, status) {
            
            try{
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"],false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            router.navigate("configuration", true);
                        //router.refresh(true);
                        //navigation.unauthorized();
                    })
                }
                else{
                
                    var msg = 'Exception: ' + error.responseText + ' | Source:ajaxFail in GetRiskLevelDescription() method in RiskFactor.js';
                    logger.logMessage(msg);
              
                }
            }catch(e)
            {
                    var msg = 'Exception: ' + e + ' | Source:ajaxFail in GetRiskLevelDescription() method in RiskFactor.js';
                    logger.logMessage(msg);
            }
        };
    }




    function GetAllRiskAreas(GetAllRiskAreasAjax) {
       // 
        try{
            $.ajax(GetAllRiskAreasAjax)
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetAllRiskAreas() method in RiskFactor.js';
                logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            // 
            try{
                if (jsonResult != 'undefined' && jsonResult != null) {
                    if (jsonResult[0].Flag == 1) {
                        var mappedRiskAreas = $.map(jsonResult, function (result) {
                            return new RiskAreaModel(result);
                        })

                        RiskFactorViewModal.RiskAreasList(mappedRiskAreas);
                        
                        for (var i = 0, j = RiskFactorViewModal.RiskAreasList().length; i < j ; i++)
                        {
                            RiskFactorViewModal.RiskAreaDrpDwnList.push(RiskFactorViewModal.RiskAreasList()[i].RiskAreaName);
                        }
                    }
                    else {

                    }
                }
                else {
                    RiskFactorViewModal.RiskAreaDrpDwnList.push("No Risk Area exist. Please add one.");
                    //app.showMessage("You have been logged out. Please log-in again to complete the Operation !!", "Error in Edit Operation", ["OK"]);
                }
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in GetAllRiskAreas() method in RiskFactor.js';
                logger.logMessage(msg);
            }
        };
        function ajaxFail(error, status) {
            // 
            try{
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"],false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            router.navigate("configuration", true);
                        //router.refresh(true);
                        //navigation.unauthorized();
                    })
                }else{
                    var msg = 'Exception: ' + error.responseText + ' | Source:ajaxFail in GetAllRiskAreas() method in RiskFactor.js';
                    logger.logMessage(msg);
                }
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail GetAllRiskAreas() method in RiskFactor.js';
                logger.logMessage(msg);
            }
        };


    };




    function GetAllRiskFactors(GetAllRiskFactorsAjax) {
       // 
        try{
            $.ajax(GetAllRiskFactorsAjax)
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetAllRiskFactors() method in RiskFactor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            // 
            try{
                if (jsonResult != 'undefined' && jsonResult != null) {
                    if (jsonResult[0].Flag == 1) {
                        var mappedRiskFactors = $.map(jsonResult, function (result) {
                            return new RiskFactorModel(result);
                        })

                        RiskFactorViewModal.RiskFactorList(mappedRiskFactors);
                        RfTableObj = $('#tblRiskFactor').DataTable({
                            "bResponsive": true,
                            
                           
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bSortable": false,

                            "sClass": "details-control"

                        },{
                            "aTargets": [0],
                            "bVisible": true,
                            "bSortable": true

                            }, {
                                "aTargets": [1],
                            "bVisible": false,
                            "bSortable": false

                        }, {
                            "aTargets": [2],
                            "bSortable": true
                        }, {
                                "aTargets": [3],
                            "bSortable": true
                        }, {
                            "aTargets": [4],
                                "bSortable": false,
                            "sClass": "text-center"
                        }],
                            fnDrawCallback: tableCallBack

                        });
                    }
               
                }
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in GetAllRiskFactors() method in RiskFactor.js';
                logger.logMessage(msg);
            }
        };
        function ajaxFail(error, status) {
            
            try{
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"],false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            router.navigate("configuration", true);
                        //router.refresh(true);
                        //navigation.unauthorized();
                    })
                }else{
                    var msg = 'Exception: ' + error.responseText + ' | Source:ajaxFail in GetAllRiskFactors() method in RiskFactor.js';
                    logger.logMessage(msg);
                }
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail in GetAllRiskFactors() method in RiskFactor.js';
                logger.logMessage(msg);
            }
        };


    };


    function addRiskFactor(data) {
        // 
        try{
            AddRiskFactorAjax = {
                url: "/api/Configuration/AddRiskFactor",
                headers: appsecurity.getSecurityHeaders(),
                type: "POST",
                data: { RiskFactorId: data.RiskFactorId(), RiskFactorName: data.RiskFactorName(), RiskAreaId: data.RiskAreaId(), RiskAreaName: data.RiskAreaName() }
            };


            $.ajax(AddRiskFactorAjax)
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source:ajax call in addRiskFactor() method in RiskFactor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            // 
            try{
                if (jsonResult != null) {
                    if (jsonResult.RiskFactorId != 0 && jsonResult.RiskFactorName != null) {
                        var newRiskFactor = new RiskFactorModel(jsonResult);
                        RiskFactorViewModal.RiskFactorList.push(newRiskFactor);
                        var node = RfTableObj.row.add(['<div style="display:none"></div>', newRiskFactor.RiskFactorId(), newRiskFactor.RiskFactorName(), newRiskFactor.RiskAreaName(), '<a href="javascript:void(0)" title="Edit" class="btn-borderless widget-button" data-bind="click: $root.editFunctionality,css:{disabled: (!$root.appsecurity.finalConfigurationSave())}"><i class="demo-icon icon-file_edit_special text-success">g</i></a><a href="javascript:void(0)" title="Delete" class="btn-borderless widget-button" data-bind="click: $root.deleteFunctionality,css:{disabled: (!$root.appsecurity.finalConfigurationSave())}"><i class="demo-icon icon-bin_special text-danger ">5</i></a>']).draw(false);
                        var addedRow = $('#tblRiskFactor').find('tr').get(1);
                        RfTableObj.page('last').draw(false);
                        ko.applyBindingsToNode($(node.node()).find('a').get(0), { click: RiskFactorViewModal.editFunctionality, css: { 'disabled': (!RiskFactorViewModal.appsecurity.finalConfigurationSave()) } }, newRiskFactor);
                        ko.applyBindingsToNode($(node.node()).find('a').get(1), { click: RiskFactorViewModal.deleteFunctionality, css: { 'disabled': (!RiskFactorViewModal.appsecurity.finalConfigurationSave()) } }, newRiskFactor);
                        ko.applyBindingsToNode($(node.node()).find('td').get(0));
                        logger.logSuccess('Risk Factor added successfully.', 'Success', system.getModuleId(RiskFactorViewModal), true);

                   
                    }
                    else {
                        logger.logError('Failed to Add Risk Factor', 'Error', system.getModuleId(RiskFactorViewModal), true);
                    }
                }
                else {
                    logger.logError('Some Error in the Application. Please contact your Application Maintenance Team.', 'Error', system.getModuleId(RiskFactorViewModal), true);
                    // app.showMessage("Some Error in the Application. Please contact your Application Maintenance Team.", "Error in Add Operation", ["OK"]);
                }
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in addRiskFactor() method in RiskFactor.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            // 
            try{
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please log-in again to complete the Operation !!", "Error in Edit Operation", ["OK"])
                    .then(function (option) {
                        if (option == "OK")
                            router.navigate("configuration", true);
                        //router.refresh(true);
                        //navigation.unauthorized();
                    })
                }else{
                    var msg = 'Exception: ' + error.responseText + ' | Source:ajaxFail in addRiskFactor() method in RiskFactor.js';
                    logger.logMessage(msg);
                }
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail in addRiskFactor() method in RiskFactor.js';
                logger.logMessage(msg);
            }
        };
    }


    function updateRiskFactor(data) {
        // 
        try{
            UpdateRiskFactorAjax = {
                url: "/api/Configuration/UpdateRiskFactor",
                headers: appsecurity.getSecurityHeaders(),
                type: "POST",
                data: { RiskFactorId: data.RiskFactorId(), RiskFactorName: data.RiskFactorName(), RiskAreaId: data.RiskAreaId(), RiskAreaName: data.RiskAreaName() }
            };


            $.ajax(UpdateRiskFactorAjax)
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source:ajax call in updateRiskFactor() method in RiskFactor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(result, status) {
         
            try{
                if (result == 1) {
                    var rowIndex = data.TargetRow();
                    RiskFactorViewModal.RiskFactorList()[rowIndex].RiskFactorId(data.RiskFactorId());
                    RiskFactorViewModal.RiskFactorList()[rowIndex].RiskFactorName(data.RiskFactorName());
                    var node = RfTableObj.row(rowIndex).data(['<div style="display:none"></div>', data.RiskFactorId(), data.RiskFactorName(), data.RiskAreaName(), '<a href="javascript:void(0)" title="Edit" class="btn-borderless widget-button" data-bind="click: $root.editFunctionality,css:{disable: (!$root.appsecurity.finalConfigurationSave())}"><i class="demo-icon icon-file_edit_special text-success">g</i></a><a href="javascript:void(0)" title="Delete" class="btn-borderless widget-button" data-bind="click: $root.deleteFunctionality,css:{disabled: (!$root.appsecurity.finalConfigurationSave())}"><i class="demo-icon icon-bin_special text-danger ">5</i></a>']).draw(false);
                    ko.applyBindingsToNode($(node.node()).find('a').get(0), { click: RiskFactorViewModal.editFunctionality, css: { 'disabled': (!RiskFactorViewModal.appsecurity.finalConfigurationSave()) } }, data);
                    ko.applyBindingsToNode($(node.node()).find('a').get(1), { click: RiskFactorViewModal.deleteFunctionality, css: { 'disabled': (!RiskFactorViewModal.appsecurity.finalConfigurationSave()) } }, data);
                    //ko.applyBindingsToNode($(node.node()).find('td').get(0));
                    ko.applyBindingsToNode($(node.node()).find('td').get(0), {}, RiskFactorViewModal);
              
                    logger.logSuccess('Risk Factor updated successfully.', 'Success', system.getModuleId(RiskFactorViewModal), true);

                }
                else if (result == 0) {
                    logger.logWarning('No such Risk Factor exists. Please refresh the page again and perform the edit operation.', 'Warning', system.getModuleId(RiskFactorViewModal), true);
                    //    app.showMessage("No Such Risk Factor Exists. Please Refresh the Page again and peform the Edit", "Error in Edit Operation", ["OK"]);
                }
                else {
                    logger.logError('Some error occured. Please refresh the page again and perform the edit operation.', 'Error', system.getModuleId(RiskFactorViewModal), true);
                    // app.showMessage("Some Error Occured. Please Refresh the Page again and peform the Edit", "Error in Edit Operation", ["OK"]);
                }
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in updateRiskFactor() method in RiskFactor.js';
                logger.logMessage(msg);
            }
        }


        function ajaxFail(error, status) {
            // 
            try{
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"],false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }else{
                    var msg = 'Exception: ' + error.responseText + ' | Source:ajaxFail in updateRiskFactor() method in RiskFactor.js';
                    logger.logMessage(msg);
                }
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail in updateRiskFactor() method in RiskFactor.js';
                logger.logMessage(msg);
            }
        }
    }


    function deleteRiskFactor(data,event)
    {
        // 
        try{
            $.ajax({
                url: "/api/Configuration/DeleteRiskFactor?RiskFactorID=" + data.RiskFactorId(),
                type: "DELETE",
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source:ajax call in deleteRiskFactor() method in RiskFactor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(result, status) {
          
            try{
                if (result == 1) {
                    var targetRow = $(event.currentTarget).closest("tr").get(0);
                    data.TargetRow(targetRow._DT_RowIndex);
                    RfTableObj.row(targetRow).remove().draw(false);
                    RiskFactorViewModal.RiskFactorList.splice(data.TargetRow(), 1);
                    //RiskFactorViewModal.RiskFactorList.remove(data);
                    logger.logSuccess('Risk Factor deleted successfully.', 'Success', system.getModuleId(RiskFactorViewModal), true);
                }
                else if (result == 0) {
                    logger.logWarning('No such Risk Factor exists. Please refresh the page again and perform the delete operation.', 'Warning', system.getModuleId(RiskFactorViewModal), true);
                    //  app.showMessage("No Such Risk Factor Exists. Please Refresh the Page again and peform the Delete", "Error in Delete Operation", ["OK"]);
                }
                else {
                    logger.logError('Some error occured. Please refresh the page again and perform the delete operation.', 'Error', system.getModuleId(RiskFactorViewModal), true);
                    //  app.showMessage("Some Error Occured. Please Refresh the Page again and peform the Delete", "Error in Delete Operation", ["OK"]);
                }
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in deleteRiskFactor() method in RiskFactor.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            // 
            try{
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"],false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }else{
                    var msg = 'Exception: ' + error.responseText + ' | Source:ajaxFail in deleteRiskFactor() method in RiskFactor.js';
                    logger.logMessage(msg);
                }
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail in deleteRiskFactor() method in RiskFactor.js';
                logger.logMessage(msg);
            }
        }
    }


    function savePopUpButton(data) {
        // 
        try{
            if (data.RiskAreaName() == 'Not-Mapped')
                data.RiskAreaId(0);
            else {
                for (var i = 0, j = RiskFactorViewModal.RiskAreasList().length; i < j; i++) {
                    if(data.RiskAreaName() == RiskFactorViewModal.RiskAreasList()[i].RiskAreaName())
                        data.RiskAreaId(RiskFactorViewModal.RiskAreasList()[i].RiskAreaId())
                }
            };
            $('#valError').hide();
            var duplicateCheck = 0;
       
            for (var i = 0, j = RiskFactorViewModal.RiskFactorList().length; i < j; i++) {
                if ((data.RiskFactorName().toUpperCase() == RiskFactorViewModal.RiskFactorList()[i].RiskFactorName().toUpperCase()) && (data.TargetRow() != i))
                    duplicateCheck++;
            }

            if (data.RiskFactorName() == "") {
                $('#valError').show();
                $('#valError').text('Risk Factor name is required.');
            }
            else if (data.RiskFactorName().length >100)
            {
                $('#valError').show();
                $('#valError').text('Risk Factor name cannot exceed 200 characters. Please Enter valid Risk Factor');
            }
            else {
                if (!isEdit) {
                    if (duplicateCheck == 1) {
                   
                        $('#valError').show();
                        $('#valError').text(data.RiskFactorName() + ' already exists. Please enter a different Risk Factor.');
                    }
                    else {
                        addRiskFactor(data);
                        $('#frmRiskFactor').modal('hide');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                    }
                }
                else {
                    if (duplicateCheck == 1) {
                   
                        $('#valError').show();
                        $('#valError').text(data.RiskFactorName() + ' already exists. Please enter a different Risk Factor.');
                    }
                    else {
                        updateRiskFactor(data);
                        $('#frmRiskFactor').modal('hide');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                    }
                }
            }

        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source:savePopUpButton() method in RiskFactor.js';
            logger.logMessage(msg);
        }

    };


    function addFunctionality() {
        // 
        try{
            RiskFactorViewModal.RiskAreaDrpDwnList.push("Not-Mapped");
            GetAllRiskAreas(GetAllRiskAreasAjax);
            var newRiskFactor = new RiskFactorModel({ RiskFactorId: 11, RiskFactorName: ""});
            RiskFactorViewModal.editableRiskFactor(newRiskFactor);
            RiskFactorViewModal.popUpTitle("Add Risk Factor Details");
        RiskFactorViewModal.addPopUpCss(true);
        RiskFactorViewModal.editPopUpCss(false);
            $('#frmRiskFactor').modal('show');
            $('#modalContentFactor').css({
                'margin-top': '30%'

            });
            isEdit = false;
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source:addFunctionality() method in RiskFactor.js';
            logger.logMessage(msg);
        }
    };

    function editFunctionality(data, event) {
        // 
        try {
            if (!RiskFactorViewModal.configuartionSaveState()) {
                RiskFactorViewModal.RiskAreaDrpDwnList.push("Not-Mapped");
                GetAllRiskAreas(GetAllRiskAreasAjax);

                var selectedRow = $(event.currentTarget).closest("tr").get(0);
                data.TargetRow(selectedRow._DT_RowIndex);
                var newObservable = new RiskFactorModel({ RiskFactorId: data.RiskFactorId(), RiskFactorName: data.RiskFactorName(), RiskAreaId: data.RiskAreaId(), RiskAreaName: data.RiskAreaName() });
                newObservable.TargetRow(selectedRow._DT_RowIndex);
                RiskFactorViewModal.editableRiskFactor(newObservable);
                RiskFactorViewModal.popUpTitle("Edit Risk Factor Details");
                RiskFactorViewModal.addPopUpCss(false);
                RiskFactorViewModal.editPopUpCss(true);
                $('#frmRiskFactor').modal('show');
                $('#modalContentFactor').css({
                    'margin-top': '30%'

                });
                isEdit = true;
            }
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source:editFunctionality() method in RiskFactor.js';
            logger.logMessage(msg);
        }
    };

    function deleteFunctionality(data, event) {
        //
        try {
            if (!RiskFactorViewModal.configuartionSaveState()) {
                app.showMessage('Are you sure you want to delete this Risk Factor?', 'Delete Risk Factor', ['Confirm', 'Cancel'])
                    .then(function (option) {
                        if (option === 'Confirm') {
                            deleteRiskFactor(data, event);
                        }
                    });
            }
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source:deleteFunctionality() method in RiskFactor.js';
            logger.logMessage(msg);
        }
    };


    function cancelPopUpButton(data) {
        try{
            $('#frmRiskFactor').modal('Hide');
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source:cancelPopUpButton() method in RiskFactor.js';
            logger.logMessage(msg);
        }
    }



    function RiskFactorModel(item) {
        var self = this;
        self.RiskFactorName = ko.observable($('<div/>').html(item.RiskFactorName).text());
        self.RiskFactorId = ko.observable(item.RiskFactorId);
        self.RiskAreaId = ko.observable(item.RiskAreaId);
        self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
        RiskFactorViewModal.SelectedAreaName($('<div/>').html(item.RiskAreaName).text());
        self.TargetRow = ko.observable();
        
    };

    function RiskAreaModel(item) {
        var self = this;
        self.RiskAreaId = ko.observable(item.RiskAreaId);
        self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
    }

    
    //------------------------------------------------------Logic for Risk Sub Factor Starts Here------------------------------------------------------------------------------------------

    function format(data) {
        try{
            var X = 3;
            var Y = 3;
            // 
            RiskFactorViewModal.RiskFactorId(data[1]);
            GetAllRiskSubFactorsAjax = {
                url: "/api/Configuration/GetRiskSubFactor?RiskFactorId=" + data[1], 
                type: "GET",
                async: false,
                headers: appsecurity.getSecurityHeaders()
            };
            GetAllRiskSubFactors(GetAllRiskSubFactorsAjax);

            GetThresholdRules();

            return '<div class="child-active"><div class="panel panel-success"><div class="panel-heading"><h3 class="panel-title riskFactorCellPanel">Sub Factors Summary<button id="addSubFactorBtn" class="btn btn-success btn-xs pull-right" data-bind="click: addRiskSubFactorFunctionality" title="Click to add new Risk SubFactor"><i class="fa fa-plus"></i> Add SubFactor</button></div></h3></div>' +
                    '<br/><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">' +
                        '<table id="subfactor" class="display" cellspacing="0">' +
                            '<thead>'+
                                '<tr>' +
                                    '<th style="display:none">Subfactor ID</th>'+
                                    '<th>Subfactor Name</th>' +
                                    '<th>Risk Score</th>' +
                                    '<th>Actions</th>'+
                                '</tr>' +
                            '</thead>' +
                            '<tbody data-bind="foreach: RiskSubFactorsList">' +
                                '<tr>' +
                                    '<td style="display:none" data-bind="text: RiskSubfactorId"></td>' +
                                    '<td data-bind="text: RiskSubfactorName"></td>' +
                                    '<td data-bind="text: RiskScore"></td>' +
                                    '<td class="text-center">' +
                                    '<a href="javascript:void(0)" title="Edit" class="btn-borderless widget-button" data-bind="click: $root.editRiskSubFactorFunctionality,css: { disabled: (!$root.appsecurity.finalConfigurationSave()) }">' +
                                        '<i class="demo-icon icon-file_edit_special text-success">g</i>' +
                                        '</a>'+
                                    '<a href="javascript:void(0)" title="Delete" class="btn-borderless widget-button" data-bind="click: $root.deleteRiskSubFactorFunctionality, css: { disabled: (!$root.appsecurity.finalConfigurationSave()) }">' +
                                        '<i class="demo-icon icon-bin_special text-danger ">5</i>' +
                                        '</a>' +
                                    '</td>'+
                                '</tr>' +
                            '</tbody>' +
                        '</table>' +
                    '</div>' +
                    '<br/>' +
                    '<div><span class="panel-heading text-success"><h3 class="panel-title threshold riskFactorCellPanel">Threshold Summary</h3></span></div></div>' +
                    
                    //'<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><table id="Threshold" class="dataTable" cellspacing="0"><thead><tr>' + thresholdtable() + '</tr></thead><tbody>' + thresholdtablebody() + '</tbody></table></div>';
                '<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 child-active">' + thresholdTableGeneration() + '</div>';
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source:format() method in RiskFactor.js';
            logger.logMessage(msg);
        }
    }
    // for adding heading to the threshold table

    function thresholdTableGeneration() {
        try{
            var tableString;



            tableString = '<label class="field-validation-error" id="lblThresholdError" style="display:none"></label><table id="Threshold" class="display" cellspacing="0">';
            tableString += '<thead><tr>';

            for (var i = 0, j = RiskFactorViewModal.RiskLevel() ; i <= j; i++) {
                tableString += '<th class="site_name">'
                if (i == 0) {
                    tableString += 'Risk Score(Vertical)/Risk Level(Horizontal)' 
                }
                else {
                    tableString += RiskFactorViewModal.RiskLevelDescription()[i-1];
                }
                tableString += '</th>'            
            }

            tableString += '</tr></thead>';

            //Logic To build the tbody

            tableString += '<tbody data-bind="foreach: ThresholdValues">';
            tableString += '<tr>';
            tableString += '<td data-bind="text: RiskScoreLevel"></td>';

            for (var i = 0, j = RiskFactorViewModal.RiskLevel() ; i < j ; i++) {
                tableString += '<td class="thresholdPointer" data-toggle="tooltip" data-placement="left" title="Double Click to enter the value&#10;Hit Enter to submit" data-bind="text: ((' + RiskFactorViewModal.RiskLevelDescription()[i] + ' == null || ' + RiskFactorViewModal.RiskLevelDescription()[i] + ' == 0) ? 0: ' + RiskFactorViewModal.RiskLevelDescription()[i] + ')"></td>';
            }
            //tableString += '<td data-bind="text: MODERATE"></td>';
            //tableString += '<td data-bind="text: HIGH""></td>';
            tableString += '</tr></tbody>';
            tableString += '</table>';

            return tableString;
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source:thresholdTableGeneration() method in RiskFactor.js';
            logger.logMessage(msg);
        }
    };




    

    function GetAllRiskSubFactors(GetAllRiskSubFactorsAjax) {
        try{
            $.ajax(GetAllRiskSubFactorsAjax)
            .success(ajaxSuccess)
            .fail(ajaxFail);

        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetAllRiskSubFactors() method in RiskFactor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            //
            try{
                var mappedRiskSubFactors = $.map(jsonResult, function (result) {
                    return new RiskSubFactorModel(result);
                });

                RiskFactorViewModal.RiskSubFactorsList(mappedRiskSubFactors);
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in GetAllRiskSubFactors() method in RiskFactor.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            
            try{
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"],false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                } else {
                    var msg = 'Exception: ' + error.responseText + ' | Source:ajax call in GetAllRiskSubFactors() method in RiskFactor.js';
                    logger.logMessage(msg);
                }
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source:ajaxfail in GetAllRiskSubFactors() method in RiskFactor.js';
                logger.logMessage(msg);
            }
        };
    };



    function GetThresholdRules() {
        
        try{
            $.ajax({
                url: "/api/Configuration/GetThresholdRules?FactorId=" + RiskFactorViewModal.RiskFactorId() + "&RiskScore=" + RiskFactorViewModal.RiskScore() + "&RiskLevel=" + RiskFactorViewModal.RiskLevel(),
                type: "GET",
                async: false
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetThresholdRules() method in RiskFactor.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            //   
            try{
                if (jsonResult != null) {
                    RiskFactorViewModal.ThresholdValues(jsonResult);
                    
                }
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in GetThresholdRules() method in RiskFactor.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            // 
            try{
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"],false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                } else {
                    var msg = 'Exception: ' + error.responseText + ' | Source:ajaxFail in GetThresholdRules() method in RiskFactor.js';
                    logger.logMessage(msg);
                }
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail in GetThresholdRules() method in RiskFactor.js';
                logger.logMessage(msg);
            }
        };
    }

    function checkExpandedRow(row, isPaginating) {
      ;
        try{
            var currentRowIndex;
            var rowsInTable = $('#tblRiskFactor').find('tr');
            if (isPaginating)
                currentRowIndex = -1;
            else
                currentRowIndex = row.index();
            var info = RfTableObj.page.info();
            for (var i = 1, j = (rowsInTable.length) ; i < j; i++) {
                //if (currentRowIndex != (i - 1)) {
                var tr = $('#tblRiskFactor').find('tr').get(i);
                if (RfTableObj.row(tr).index() != row.index()) {
                var tableRowIndex = (info.page * info.length) + (i - 1);
               
                    if ((RfTableObj.row(tableRowIndex).child() != undefined) && (RfTableObj.row(tableRowIndex).child.isShown())) {
                        RfTableObj.row(tableRowIndex).child.remove();
                        tr.removeAttribute('class', 'shown')
                        j = $('#tblRiskFactor').find('tr').length;
                    }
                }
            }

            //
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: checkExpandedRow() method in RiskFactor.js';
            logger.logMessage(msg);
        }

    } // End of checkExpandedRow()



    function addRiskSubFactor(data) {
        // 
        try{
            $.ajax({
                url: "/api/Configuration/AddRiskSubFactor",
                headers: appsecurity.getSecurityHeaders(),
                type: "POST",
                data: {RiskFactorId: data.RiskFactorId(), RiskSubfactorId: data.RiskSubfactorId(), RiskSubfactorName: data.RiskSubfactorName(), RiskScore: data.RiskScore()}
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: ajax call in addRiskSubFactor() method in RiskFactor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
         
            try{
                if (jsonResult != null) {
                    if (jsonResult.flag == 1) {
                        var newRiskSubfactor = new RiskSubFactorModel(jsonResult);
                        RiskFactorViewModal.RiskSubFactorsList.push(newRiskSubfactor);
                        RfSubFactorTableObj.draw(false);

                       var node = RfSubFactorTableObj.row.add([newRiskSubfactor.RiskSubfactorId(), newRiskSubfactor.RiskSubfactorName(), newRiskSubfactor.RiskScore(), '<a href="javascript:void(0)" title="Edit" class="btn-borderless widget-button" data-bind="click: $root.editRiskSubFactorFunctionality,css: { disabled: (!$root.appsecurity.finalConfigurationSave()) }"><i class="demo-icon icon-file_edit_special text-success">g</i></a><a href="javascript:void(0)" title="Delete" class="btn-borderless widget-button" data-bind="click: $root.deleteRiskSubFactorFunctionality, css: { disabled: (!$root.appsecurity.finalConfigurationSave()) }"><i class="demo-icon icon-bin_special text-danger ">5</i></a>']).draw(false);
                       RfSubFactorTableObj.page('last').draw(false);
                       var addedRow = $('#subfactor').find('tr').get(1);
                       ko.applyBindingsToNode($(node.node()).find('a').get(0), { click: RiskFactorViewModal.editRiskSubFactorFunctionality, css: { 'disabled': (!RiskFactorViewModal.appsecurity.finalConfigurationSave()) } }, newRiskSubfactor);
                       ko.applyBindingsToNode($(node.node()).find('a').get(1), { click: RiskFactorViewModal.deleteRiskSubFactorFunctionality, css: { 'disabled': (!RiskFactorViewModal.appsecurity.finalConfigurationSave()) } }, newRiskSubfactor);
                    
                        logger.logSuccess('Risk Sub-Factor added successfully.', 'Success', system.getModuleId(RiskFactorViewModal), true);
                    }
                    else {
                        logger.logError('Risk Sub-Factor already exists. Please try adding a different Risk Sub-Factor', 'Error', system.getModuleId(RiskFactorViewModal), true);
                    }
                }
                else {
                    logger.logError('Failed to add Risk Sub-Factor.', 'Error', system.getModuleId(RiskFactorViewModal), true);
                };
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in addRiskSubFactor() method in RiskFactor.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            
            try{
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"],false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                } else {
                    var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in addRiskSubFactor() method in RiskFactor.js';
                    logger.logMessage(msg);
                }
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in addRiskSubFactor() method in RiskFactor.js';
                logger.logMessage(msg);
            }
        };
    };


    function updateRiskSubFactor(data) {
     
        try{
            var editedData = data;
            $.ajax({
                url: "/api/Configuration/UpdateRiskSubFactor",
                headers: appsecurity.getSecurityHeaders(),
                type: "POST",
                data: data
            })
            .success(ajaxSuccess)
            .fail(ajaxFail)
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: ajax call in updateRiskSubFactor() method in RiskFactor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
       
            try{
                if (jsonResult != null) {
                    if (jsonResult == 1) {
                        var rowIndex = data.TargetRow();
                        //RiskFactorViewModal.RiskSubFactorsList()[rowIndex].RiskSubfactorName(data.RiskSubfactorName());
                        //RiskFactorViewModal.RiskSubFactorsList()[rowIndex].RiskScore(data.RiskScore());

                        //for (var i = 0, j = RiskFactorViewModal.RiskSubFactorsList().length; i < j; i++) {
                        //    if (data.RiskSubfactorId() == RiskFactorViewModal.RiskSubFactorsList()[i].RiskSubfactorId()) {
                        //        RiskFactorViewModal.RiskSubFactorsList()[i].RiskSubfactorName(data.RiskSubfactorName());
                        //        RiskFactorViewModal.RiskSubFactorsList()[i].RiskScore(data.RiskScore());
                        //    }
                        //}
                        RiskFactorViewModal.RiskSubFactorsList()[rowIndex].RiskSubfactorId(data.RiskSubfactorId());
                        RiskFactorViewModal.RiskSubFactorsList()[rowIndex].RiskSubfactorName(data.RiskSubfactorName());
                        RiskFactorViewModal.RiskSubFactorsList()[rowIndex].RiskScore(data.RiskScore());
                        var node = RfSubFactorTableObj.row(rowIndex).data([data.RiskSubfactorId(), data.RiskSubfactorName(), data.RiskScore(), '<a href="javascript:void(0)" title="Edit" class="btn-borderless widget-button" data-bind="click: $root.editRiskSubFactorFunctionality,css: { disabled: (!$root.appsecurity.finalConfigurationSave()) }"><i class="demo-icon icon-file_edit_special text-success">g</i></a><a href="javascript:void(0)" title="Delete" class="btn-borderless widget-button" data-bind="click: $root.deleteRiskSubFactorFunctionality, css: { disabled: (!$root.appsecurity.finalConfigurationSave()) }"><i class="demo-icon icon-bin_special text-danger ">5</i></a>']).draw(false);
                      //  RfSubFactorTableObj.draw(false);
                        ko.applyBindingsToNode($(node.node()).find('a').get(0), { click: RiskFactorViewModal.editRiskSubFactorFunctionality, css: { 'disabled': (!RiskFactorViewModal.appsecurity.finalConfigurationSave()) } }, data);
                        ko.applyBindingsToNode($(node.node()).find('a').get(1), { click: RiskFactorViewModal.deleteRiskSubFactorFunctionality, css: { 'disabled': (!RiskFactorViewModal.appsecurity.finalConfigurationSave()) } }, data);



                        logger.logSuccess('Risk Sub-Factor updated successfully.', 'Success', system.getModuleId(RiskFactorViewModal), true);
                    }
                    else if (jsonResult == 0) {
                        logger.logError('Risk Sub-Factor already exists. Please try updating the Risk Sub-Factor with a different Name.', 'Error', system.getModuleId(RiskFactorViewModal), true);
                    }
                    else if (jsonResult == -1) {
                        logger.logError('Some error occured. Please try again by refreshing the page.', 'Error', system.getModuleId(RiskFactorViewModal), true);
                    }
                };
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source:Success in updateRiskSubFactor() method in RiskFactor.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            
            try{
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"],false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in updateRiskSubFactor() method in RiskFactor.js';
                    logger.logMessage(msg);
                }
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in updateRiskSubFactor() method in RiskFactor.js';
                logger.logMessage(msg);
            }
        };
    };



    function deleteRiskSubFactor(data, event) {
        // 
        try{
            $.ajax({
                url: "/api/Configuration/DeleteSubRiskFactor?SubRiskFactorId=" + data.RiskSubfactorId(),
                type: "DELETE"
            })
            .success(ajaxSuccess)
            .fail(ajaxFail)
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: ajax call in deleteRiskSubFactor() method in RiskFactor.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            
            try{
                if (jsonResult != null) {
                    if (jsonResult == 1) {
                     //   var rowIndex = data.TargetRow();
                      //  RiskFactorViewModal.RiskSubFactorsList.remove(data);

                        var targetRow = $(event.currentTarget).closest("tr").get(0);
                        data.TargetRow(targetRow._DT_RowIndex);
                        RfSubFactorTableObj.row(targetRow).remove().draw(false);
                        RiskFactorViewModal.RiskSubFactorsList.splice(data.TargetRow(), 1);
                        logger.logSuccess('Risk Sub-Factor deleted successfully.', 'Success', system.getModuleId(RiskFactorViewModal), true);
                    }
                    else if (jsonResult == 0) {
                        logger.logError('Risk Sub-Factor does not exist or has already been deleted. Please try reloading the page and re-try delete operation.', 'Error', system.getModuleId(RiskFactorViewModal), true);
                    }
                    else if (jsonResult == -1) {
                        logger.logError('Some error Occured. Please try again by refreshing the page.', 'Error', system.getModuleId(RiskFactorViewModal), true);
                    }
                };
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in deleteRiskSubFactor() method in RiskFactor.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            // 
            try{
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"],false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                } else {
                    var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in deleteRiskSubFactor() method in RiskFactor.js';
                    logger.logMessage(msg);
                }
            }catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in deleteRiskSubFactor() method in RiskFactor.js';
                logger.logMessage(msg);
            }
        };
        
    }

    function editRiskSubFactorFunctionality(data, event) {
       
        try{
            //var selectedRow = $(event.currentTarget).closest("tr").get(0);
            for(var i=0, j = RiskFactorViewModal.RiskSubFactorsList().length; i<j;i++)
            {
                if(data.RiskSubfactorName() == RiskFactorViewModal.RiskSubFactorsList()[i].RiskSubfactorName())
                    data.TargetRow(i);
            }
            
            var newRsfObservable = new RiskSubFactorModel({ RiskFactorId: data.RiskFactorId(), RiskSubfactorId: data.RiskSubfactorId(), RiskSubfactorName: data.RiskSubfactorName(), RiskScore: data.RiskScore() });
            newRsfObservable.TargetRow(data.TargetRow());
            RiskFactorViewModal.editableRiskSubFactor(newRsfObservable);
            RiskFactorViewModal.rsfPopUpTitle("Edit Risk Sub Factor Details");
            var test = RiskFactorViewModal.editableRiskSubFactor().RiskScore();
            //ko.applyBindingsToNode($('#frmSubFactor').find('h4').get(0), { text: RiskFactorViewModal.rsfPopUpTitle() }, RiskFactorViewModal);
            //ko.applyBindingsToNode($('#frmSubFactor').find('form').get(0), { with: RiskFactorViewModal.editableRiskSubFactor() }, RiskFactorViewModal);
            ko.applyBindingsToNode($('#frmSubFactor').find('input').get(0), { value: RiskFactorViewModal.editableRiskSubFactor().RiskSubfactorName }, RiskFactorViewModal);
            //ko.applyBindingsToNode($('#frmSubFactor').find('select').get(0), { options: RiskFactorViewModal.RiskScoreDrpDwnList, value: test}, RiskFactorViewModal);
        RiskFactorViewModal.addPopUpCss(false);
        RiskFactorViewModal.editPopUpCss(true);
            $('#frmSubFactor').modal('show');
            $('#modalContentSubFactor').css({
                'margin-top': '30%'
            })
            isRsfEdit = true;
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: editRiskSubFactorFunctionality() method in RiskFactor.js';
            logger.logMessage(msg);
        }
    }


    function addRiskSubFactorFunctionality(data, event) {
      
        try{
            var newRiskSubFactor = new RiskSubFactorModel({ RiskFactorId: RiskFactorViewModal.RiskFactorId(), RiskSubfactorId: 999, RiskSubfactorName: "", RiskScore: 1 });
            RiskFactorViewModal.editableRiskSubFactor(newRiskSubFactor);
            RiskFactorViewModal.rsfPopUpTitle("Add Risk Sub Factor Details");
            //ko.applyBindingsToNode($('#frmSubFactor').find('button').get(1), { click: RiskFactorViewModal.saveRsfButton }, RiskFactorViewModal);
            ko.applyBindingsToNode($('#frmSubFactor').find('button').get(2), { click: RiskFactorViewModal.cancelRsfButton }, RiskFactorViewModal);
        RiskFactorViewModal.addPopUpCss(true);
        RiskFactorViewModal.editPopUpCss(false);
            $('#frmSubFactor').modal('show');
            $('#modalContentSubFactor').css({
                'margin-top': '30%'
            })
            isRsfEdit = false;
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: addRiskSubFactorFunctionality() method in RiskFactor.js';
            logger.logMessage(msg);
        }
    };

    function deleteRiskSubFactorFunctionality(data, event) {
        // 
        try{
            var selectedRow = $(event.currentTarget).closest("tr").get(0);
            data.TargetRow(selectedRow._DT_RowIndex);
            app.showMessage('Are you sure you want to delete this Risk Sub-Factor?', 'Delete Risk Sub Factor', ['Confirm', 'Cancel'])
                .then(function (option) {
                    if (option === 'Confirm') {
                        deleteRiskSubFactor(data, event);
                    }
                });
        }catch(e)
        {
            var msg = 'Exception: ' + e + ' | Source: deleteRiskSubFactorFunctionality() method in RiskFactor.js';
            logger.logMessage(msg);
        }
    };


    function saveRsfButton(data) {
    
        try{
            $('#valError').hide();
            var duplicateCheck = 0;
       
            for (var i = 0, j = RiskFactorViewModal.RiskSubFactorsList().length; i < j; i++) {
                if ((data.RiskSubfactorName().toUpperCase() == RiskFactorViewModal.RiskSubFactorsList()[i].RiskSubfactorName().toUpperCase()) && (data.TargetRow() != i))
                    duplicateCheck++;
            }

            if (data.RiskSubfactorName() == "") {
                $('#valErrorSubfactor').show();
                $('#valErrorSubfactor').text('Risk Sub-Factor name is required.');
            }
            else if (data.RiskSubfactorName().length >500)
            {
                $('#valErrorSubfactor').show();
                $('#valErrorSubfactor').text('Risk SubFactor name cannot exceed 200 characters. Please Enter valid Risk Sub-Factor');
            }
            else {
                if (!isRsfEdit) {
                    if (duplicateCheck == 1) {
                   
                        $('#valErrorSubfactor').show();
                        $('#valErrorSubfactor').text(data.RiskSubfactorName() + ' already exists. Please enter a different Risk Sub-Factor.');
                    }
                    else {
                        addRiskSubFactor(data);
                        $('#frmSubFactor').modal('hide');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                    }
                }
                else {
                    if (duplicateCheck == 1) {
                   
                        $('#valErrorSubfactor').show();
                        $('#valErrorSubfactor').text(data.RiskSubfactorName() + ' already exists. Please enter a different Risk Sub-Factor.');
                    }
                    else {
                        updateRiskSubFactor(data);
                        $('#frmSubFactor').modal('hide');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                    }
                }
            }
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: saveRsfButton() method in RiskFactor.js';
            logger.logMessage(msg);
        }
    };

    function cancelRsfButton(data) {
       // 
    };


    function RiskSubFactorModel(item) {
        var self = this;
        self.RiskFactorId = ko.observable(item.RiskFactorId);
        self.RiskSubfactorId = ko.observable(item.RiskSubfactorId);
        self.RiskSubfactorName = ko.observable(item.RiskSubfactorName);
        self.RiskScore = ko.observable(item.RiskScore);
        self.TargetRow = ko.observable(-1);
    };

    function ThresholdRulesModel(item) {
       
        var self = this;
        for (var i = 1, j = RiskFactorViewModal.RiskScore() ; i <= j; i++) {
            
        }
    }


});

